import * as React from 'react';

import Popup from '~/apps/shared/components/modals/Popup'

const PopupFunds = (props) => {
  const { onClose } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Popup>
      <div className="popup__content">
        <h2 className="popup__title">Add Funds</h2>
        <p className="popup__text">Choose the way to add funds</p>
      </div>
      <div className='popup__footer'>
        <button className="btn btn--prim btn--md btn--white" onClick={handleClose}>CLOSE</button>
      </div>
    </Popup>
  );
};

export default PopupFunds;
